import React from 'react';
import { useLanguage } from '../i18n/LanguageContext';
import { emphasize } from '../utils/emphasize';
import './About.css';

const About: React.FC = () => {
  const { t } = useLanguage();
  const a = t.about;

  return (
    <div className="about-container">
      <div className="about-content">
        <div className="about-header">
          <div className="about-logo-placeholder">
            {/* TODO: Insert logo/image here */}
            <div className="logo-box">
              <img src="/logo192.png" alt="Yarnboard" className="brand-logo-img" />
            </div>
          </div>
          <h1 className="about-title">Yarnboard</h1>
          <p className="about-tagline">{a.tagline}</p>
        </div>

        <div className="about-section">
          <h2>{a.whatIsTitle}</h2>
          <p>{emphasize(a.whatIsP1)}</p>
          <p>{emphasize(a.whatIsP2)}</p>
        </div>

        <div className="about-section">
          <h2>{a.whoForTitle}</h2>
          <p>{a.whoForIntro}</p>
          <ul>
            <li>{emphasize(a.whoFor1)}</li>
            <li>{emphasize(a.whoFor2)}</li>
            <li>{emphasize(a.whoFor3)}</li>
            <li>{emphasize(a.whoFor4)}</li>
            <li>{emphasize(a.whoFor5)}</li>
            <li>{emphasize(a.whoFor6)}</li>
            <li>{emphasize(a.whoFor7)}</li>
            <li>{emphasize(a.whoFor8)}</li>
            <li>{emphasize(a.whoFor9)}</li>
            <li>{emphasize(a.whoFor10)}</li>
            <li>{emphasize(a.whoFor11)}</li>
            <li>{emphasize(a.whoFor12)}</li>
          </ul>
        </div>

        <div className="about-section conspiracy-section">
          <h2>{a.howTitle}</h2>
          <p>{emphasize(a.howIntro)}</p>

          <div className="feature-highlight">
            <h3>{a.featBrainTitle}</h3>
            <p>{emphasize(a.featBrainBody)}</p>
          </div>

          <div className="feature-highlight">
            <h3>{a.featTagsTitle}</h3>
            <p>{emphasize(a.featTagsBody)}</p>
          </div>

          <div className="feature-highlight">
            <h3>{a.featWebTitle}</h3>
            <p>{emphasize(a.featWebBody)}</p>
          </div>

          <div className="feature-highlight">
            <h3>{a.featRecallTitle}</h3>
            <p>{emphasize(a.featRecallBody)}</p>
          </div>

          <div className="feature-highlight">
            <h3>{a.featVideoTitle}</h3>
            <p>{emphasize(a.featVideoBody)}</p>
          </div>

          <div className="feature-highlight">
            <h3>{a.featVoiceTitle}</h3>
            <p>{emphasize(a.featVoiceBody)}</p>
          </div>

          <div className="feature-highlight">
            <h3>{a.featDocsTitle}</h3>
            <p>{emphasize(a.featDocsBody)}</p>
          </div>

          <div className="feature-highlight">
            <h3>{a.featSourcesTitle}</h3>
            <p>{emphasize(a.featSourcesBody)}</p>
          </div>

          <div className="feature-highlight">
            <h3>{a.featImportTitle}</h3>
            <p>{emphasize(a.featImportBody)}</p>
          </div>

          <div className="feature-highlight">
            <h3>{a.featExtensionTitle}</h3>
            <p>{emphasize(a.featExtensionBody)}</p>
          </div>
        </div>

        <div className="about-section">
          <h2>{a.bottomTitle}</h2>
          <p>{emphasize(a.bottomP1)}</p>
          <p>{a.bottomP2}</p>
          <p className="about-cta">{emphasize(a.bottomCta)}</p>
        </div>

        <div className="about-section privacy-section">
          <h2>{a.privacyTitle}</h2>

          <h3>{a.privacyUpdated}</h3>

          <h4>{a.infoCollectTitle}</h4>
          <p>{a.infoCollectIntro}</p>
          <ul>
            <li>{a.infoCollect1}</li>
            <li>{a.infoCollect2}</li>
            <li>{a.infoCollect3}</li>
            <li>{a.infoCollect4}</li>
            <li>{a.infoCollect5}</li>
            <li>{a.infoCollect6}</li>
            <li>{a.infoCollect7}</li>
          </ul>

          <h4>{a.howUseTitle}</h4>
          <p>{a.howUseIntro}</p>
          <ul>
            <li>{a.howUse1}</li>
            <li>{a.howUse2}</li>
            <li>{a.howUse3}</li>
            <li>{a.howUse4}</li>
            <li>{a.howUse5}</li>
          </ul>

          <h4>{a.storageTitle}</h4>
          <p>{a.storageBody}</p>

          <h4>{a.thirdPartyTitle}</h4>
          <p>{a.thirdPartyIntro}</p>
          <ul>
            <li>{a.thirdParty1}</li>
            <li>{a.thirdParty2}</li>
            <li>{a.thirdParty3}</li>
          </ul>
          <p>{a.thirdPartyOutro}</p>

          <h4>{a.sharingTitle}</h4>
          <p>{emphasize(a.sharingBody)}</p>

          <h4>{a.rightsTitle}</h4>
          <p>{a.rightsIntro}</p>
          <ul>
            <li>{a.rights1}</li>
            <li>{a.rights2}</li>
            <li>{a.rights3}</li>
            <li>{a.rights4}</li>
          </ul>

          <h4>{a.retentionTitle}</h4>
          <p>{a.retentionBody}</p>

          <h4>{a.cookiesTitle}</h4>
          <p>{a.cookiesBody}</p>

          <h4>{a.changesTitle}</h4>
          <p>{a.changesBody}</p>

          <h4>{a.contactTitle}</h4>
          <p>{a.contactBody}</p>

          <h4>{a.gdprTitle}</h4>
          <p>{a.gdprBody}</p>

          <h4>{a.ccpaTitle}</h4>
          <p>{a.ccpaBody}</p>
        </div>

        <div className="about-footer">
          <p>{a.copyright}</p>
          <p className="about-version">{a.version}</p>
        </div>
      </div>
    </div>
  );
};

export default About;
